import Info from '@assets/flowchart/Info.svg'
import NodeBox from './common/NodeBox'
import NodeConsumerPicker from './common/NodeConsumerPicker'
import NodeSelect from './common/NodeSelect'
import NodeSelectMany from './common/NodeSelectMany'
import { Box } from '@mui/material'
import { useNodeData } from './common/useNodeData'
import { useReference } from '../ReferenceContext'
import {
  attributeOptions,
  attributeValueOptions,
  findAttribute,
} from '../referenceOptions'

// Options come from the per-site reference bundle, so the stored values are
// real backend identifiers: `attributeName` is the attribute's `name`. A
// 'select' attribute offers its `allowedValues` in a multi-select. A
// 'consumers' attribute has none: the author searches consumers and `values`
// are their water service ids. Either way `values` is a string list and the
// serializer emits `{ kind:'attribute', attribute, values }` unchanged.
const ConnectNode = ({ id, data }: { id: string; data: any }) => {
  const patch = useNodeData(id)
  const reference = useReference()

  const attribute = findAttribute(reference, data?.attributeName)
  const attributeName = data?.attributeName ?? null
  const attrOptions = attributeOptions(reference, attributeName)
  const values: string[] = data?.values ?? []
  const setValues = (v: string[]) => patch({ values: v })

  return (
    <NodeBox title="מאפיין שייכות" icon={Info} nodeId={id}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {attribute?.valueEntry === 'consumers' ? (
          <NodeConsumerPicker values={values} onChange={setValues} />
        ) : (
          <NodeSelectMany
            option2SelectedId={values}
            setOption2SelectedId={setValues}
            options={attributeValueOptions(reference, attributeName)}
          />
        )}
        <NodeSelect
          placeholder="מאפיין"
          options={attrOptions}
          value={attributeName}
          onChangeValue={v => patch({ attributeName: v, values: [] })}
        />
      </Box>
    </NodeBox>
  )
}

export default ConnectNode
